import React from "react";
import { Link } from "react-router-dom";

/*
teamLogoObj properties:
  - id
  - isActive
  - name
  - startWeek
  - [endWeek]
 */
class TeamLogo {
  /**
   *
   * @param {object} teamLogoObj
   * @param {Team} team
   */
  constructor(teamLogoObj, team) {
    this.obj = null;
    this.team = null;

    if (teamLogoObj && team && team.hasLoaded()) {
      this.obj = teamLogoObj;
      this.team = team;
    }
  }

  /**
   *
   * @returns {boolean}
   */
  isActive() {
    return this.hasLoaded() && this.obj.isActive;
  }

  /**
   *
   * @param {string} size
   * @param {object} [styleProps = {}]
   * @returns {JSX.Element}
   */
  getImg(size = "lg", styleProps = {}) {
    let sizeText = "lg";
    let padding = "0.5";

    if (size === "sm") {
      sizeText = "sm";
      padding = "0.25";
    } else if (size === "md") {
      styleProps = {
        ...styleProps,
        width: 72,
        height: 72,
        imageRendering: "auto",
      };
    }

    return (
      <img
        src={`/img/logos/leagues/${this.team?.leagueSlugOrId}/${this.obj?.name}_${sizeText}.gif`}
        style={{
          margin: "0",
          padding: `${padding}rem`,
          verticalAlign: "middle",
          ...styleProps,
        }}
        alt={`${this.team?.fullName} logo`}
      />
    );
  }

  getImgSm(styleProps = {}) {
    return this.getImg("sm", styleProps);
  }

  getImgMd(styleProps = {}) {
    return this.getImg("md", styleProps);
  }

  getImgLg(styleProps = {}) {
    return this.getImg("lg", styleProps);
  }

  /**
   *
   * @param {string} linkPath
   * @param {string} [size="lg"]
   * @param {object} [styleProps = {}]
   * @returns {JSX.Element}
   */
  getImgLink(linkPath, size = "lg", styleProps = {}) {
    return <Link to={linkPath}>{this.getImg(size, styleProps)}</Link>;
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    return !!this.obj && !!this.team && this.team.hasLoaded();
  }
}

export default TeamLogo;
